<template>
  <el-row :gutter="20">
    <el-col :span="7" v-if="showContainrt">
      <el-card shadow="never" style="position: relative;">
        <el-descriptions :column="1">
          <el-descriptions-item :label="'箱尺寸(m)'">
            <strong
              v-if="
                data.containerLength ||
                  data.containerWidth ||
                  data.containerHeight
              "
            >
              {{
                `${data.containerLength || 0}*${data.containerWidth ||
                  0}*${data.containerHeight || 0}`
              }}
            </strong>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="2">
          <el-descriptions-item :label="'箱容积(m³)'">
            <strong>{{ data.loadVolume }}</strong>
          </el-descriptions-item>
          <el-descriptions-item :label="'箱载重(kg)'">
            <strong>{{ data.loadWeight }}</strong>
          </el-descriptions-item>
        </el-descriptions>
        <el-progress
          class="container_progress"
          :percentage="loadVolumePercentage"
          :color="customColors"
          :show-text="false"
          :stroke-width="2"
        ></el-progress>
      </el-card>
    </el-col>
    <el-col :span="!showContainrt ? 24 : 17">
      <el-card shadow="never">
        <el-descriptions :column="!showContainrt ? 8 : 4">
          <!-- <el-descriptions-item labelClassName="no-colon" v-if="showContainrt">
          </el-descriptions-item> -->
          <el-descriptions-item
            :label="$l('INDEX.form_label_containerBoxQty') || '入柜总箱数'"
          >
            <strong>{{ data.containerBoxQty || 0 }}</strong>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.form_total_boxGoodsQty') || '总数量'"
          >
            <strong>{{ data.boxGoodsQty || 0 }}</strong>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.form_label_totalBoxVolume') || '总体积'"
          >
            <strong>{{ data.containerBoxVolume || 0 }}</strong>
          </el-descriptions-item>
          <el-descriptions-item :label="$l('INDEX.form_label_total_booking_volume') || '总订舱体积'">
            <strong>{{
              data.containerBookingVolume == 0 || data.containerBookingVolume
                ? data.containerBookingVolume
                : data.containerBoxVolume
            }}</strong>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.form_totalNetWeight') || '总净重'"
          >
            <strong>{{ data.containerNetWeight || 0 }}</strong>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.form_totalGrossWeight') || '总毛重'"
          >
            <strong>{{ data.containerGrossWeight || 0 }}</strong>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.form_total_totalPriceAmount') || '总工厂金额'"
          >
            <strong>{{ data.containerPriceAmount || 0 }}</strong>
          </el-descriptions-item>
          <el-descriptions-item
            :label="$l('INDEX.form_total_shipmentSalePrice') || '总ABS金额'"
          >
            <strong>{{ data.containerSalePriceAmout || 0 }}</strong>
          </el-descriptions-item>
        </el-descriptions>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import { divide, multiply } from '@/libs/util.number.js'
export default {
  props: {
    data: { type: Object, default: () => {} },
    showContainrt: { type: Boolean, default: true },
  },
  data() {
    return {
      customColors: [
        { color: '#5cb87a', percentage: 20 },
        { color: '#1989fa', percentage: 40 },
        { color: '#6f7ad3', percentage: 60 },
        { color: '#e6a23c', percentage: 80 },
        { color: '#f56c6c', percentage: 100 },
      ],
    }
  },
  computed: {
    loadVolumePercentage() {
      const { loadVolume, containerBoxVolume } = this.data
      if (!loadVolume || !containerBoxVolume) return 0
      const result = multiply(divide(containerBoxVolume, loadVolume), 100)
      return result > 100 ? 100 : result
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-descriptions-item__container {
  line-height: 18px;
  strong {
    font-size: 16px;
  }
}
::v-deep .el-card__body {
  padding-bottom: 8px;
}

::v-deep .no-colon::after {
  content: none;
}

.container_progress {
  opacity: 0.8;
  position: absolute;
  bottom: 4px;
  right: 4px;
  left: 4px;
}
</style>
